// https://codesandbox.io/s/hjvt8?file=/demo.js

import React from "react";
import Switch from "@material-ui/core/Switch";
import { Field, ErrorMessage } from "formik";

function Switchs(props) {
  
  const [stateSwitch, setStateSwitch] = React.useState();

  const handleChangeSwitch = (event) => {
    setStateSwitch({
      ...stateSwitch,
      [event.target.name]: event.target.checked,
    });
  };

  const {
    label,
    name,
    field,
    errorobj,
    touched,
    onChange,
    blur,
    formikobj,
    ...rest
  } = props;

  return (
    <div>
      <Field id={name} name={name} label={label} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <Switch
              id={name}
              name={name}
              label={label}
              checked={stateSwitch}
              onChange={handleChangeSwitch}
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              {...rest}
              {...field}
            />

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
}

export default Switchs;
